// import { gaWrapper } from 'helpers/analytics';

// eslint-disable-next-line import/prefer-default-export
export function attachTrackInterstitialEvents() {
  // window.trackInterstitialEvents =
  //   window.trackInterstitialEvents ||
  //   function trackInterstitialEvents(gaValues = {}) {
  //     if (typeof window.categoryForGA === 'string') {
  //       // eslint-disable-next-line no-param-reassign
  //       gaValues.eventCategory = `${window.categoryForGA}_interstitial`;
  //       gaValues.nonInteraction = 1;
  //       gaWrapper('send', 'event', gaValues);
  //     }
  //   };
}
